// extracted by mini-css-extract-plugin
module.exports = {"container":"teaser-grid-layout-module--container--2K0Gd"};